export enum RentalReservationFeeTypeEnum {
  Standard = 'Standard',
  Expedited = 'Expedited',
  Express = 'Express',
}

export const rentalReservationFeeTypeColorMap: Record<RentalReservationFeeTypeEnum, string> = {
  [RentalReservationFeeTypeEnum.Standard]: '#DCDCDC',
  [RentalReservationFeeTypeEnum.Expedited]: '#FFD889',
  [RentalReservationFeeTypeEnum.Express]: '#FFA39E',
};

export const rentalReservationFeeTypePriorityMap: Record<RentalReservationFeeTypeEnum, number> = {
  [RentalReservationFeeTypeEnum.Standard]: 1,
  [RentalReservationFeeTypeEnum.Expedited]: 2,
  [RentalReservationFeeTypeEnum.Express]: 3,
};
